import { Auth } from 'aws-amplify';
import configParams from '../../configParams.json';
import { toast } from 'react-toastify';

export async function PostMachine(machineData) {
  try {
    let URL = "";
    if (configParams.Config.AMBIENTE === "dev") {
      URL = configParams.Config.api_POST_NEW_MACHINE_dev;
    } else if (configParams.Config.AMBIENTE === "prod") {
      URL = configParams.Config.api_POST_NEW_MACHINE_prod;
    }

    const session = await Auth.currentSession();
    const token = session.getIdToken().jwtToken;

    const headers = new Headers();
    headers.append("token", token);

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(machineData),
      redirect: 'follow'
    };

    const response = await fetch(URL, requestOptions);
    const text = await response.text();
    const res = JSON.parse(text);

    if (res.statusCode !== 200) {
      throw new Error("Errore server: " + res.body);
    }

    toast.success("Macchina salvata con successo!");
    return res;
  } catch (error) {
    console.error("Errore salvataggio macchina:", error);
    toast.error("Errore salvataggio macchina.");
    throw error;
  }
}
